'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _admin = require('./admin.component');

var _admin2 = _interopRequireDefault(_admin);

var _episodes = require('../../common/admin/episodes/episodes');

var _episodes2 = _interopRequireDefault(_episodes);

var _users = require('../../common/admin/users/users');

var _users2 = _interopRequireDefault(_users);

var _specialties = require('../../common/admin/specialties/specialties');

var _specialties2 = _interopRequireDefault(_specialties);

var _episodevalue = require('../../common/admin/episodevalue/episodevalue');

var _episodevalue2 = _interopRequireDefault(_episodevalue);

var _drgs = require('../../common/admin/drgs/drgs');

var _drgs2 = _interopRequireDefault(_drgs);

var _site = require('../../common/admin/site/site');

var _site2 = _interopRequireDefault(_site);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Reports
var adminModule = _angular2.default.module('admin', [_angularUiRouter2.default, _episodes2.default.name, _users2.default.name, _specialties2.default.name, _episodevalue2.default.name, _drgs2.default.name, _site2.default.name]).config(function ($stateProvider, $urlRouterProvider) {
  "ngInject";

  $urlRouterProvider.otherwise('/');

  $stateProvider.state('admin', {
    url: '/admin',
    template: '<admin></admin>',
    authenticate: true,
    admin: "Reporter"
  }).state('admin.episodes', {
    url: '/episodes',
    template: '<episodes></episodes>',
    authenticate: true,
    admin: true
  }).state('admin.users', {
    url: '/users',
    template: '<users></users>',
    authenticate: true,
    admin: true
  }).state('admin.specialties', {
    url: '/specialties',
    template: '<specialties></specialties>',
    authenticate: true,
    admin: true
  }).state('admin.episodevalue', {
    url: '/episodevalue',
    template: '<episodevalue></episodevalue>',
    authenticate: true,
    admin: 'Reporter'
  }).state('admin.drgs', {
    url: '/drgs',
    template: '<drgs></drgs>',
    authenticate: true,
    admin: true
  }).state('admin.site', {
    url: '/site',
    template: '<site></site>',
    authenticate: true,
    admin: true
  });
}).component('admin', _admin2.default);

exports.default = adminModule;


// WEBPACK FOOTER //
// ./client/app/components/admin/admin.js